// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"id":"caret-up-small","fill":"props.strokeColor1","d":"M12.0001 9L17.5 14.5L6.5 14.5L12.0001 9Z"}}]};

const CaretUpSmallIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'caret-up-small',
    ref,
    icon: element,
  },
));

CaretUpSmallIcon.displayName = 'CaretUpSmallIcon';

export default CaretUpSmallIcon;
